import type { ContentBlock, Issue } from '@nuff/types';

/**
 * The KEPT blocks of an issue, in dense running order (dismissed ones excluded).
 * Shared so the studio's on-screen renderer and the email template agree on WHICH
 * blocks appear and in what order, not just how each block's prose is rendered.
 */
export function keptBlocksInOrder(issue: Issue): ContentBlock[] {
  return issue.blocks
    .filter((block) => block.status !== 'dismissed')
    .slice()
    .sort((a, b) => a.order - b.order);
}
